/**
 * @module components\ghDiagram
 */
import Vue from "vue";
import Component from "vue-class-component";
import go, { Diagram } from "gojs";
import { Prop, Watch, Model } from "vue-property-decorator";

/**
 * 图形编辑器，如流程图、组织架构图等
 */

@Component
export default class GhDiagram extends Vue {
  /**
   * 节点Key值
   */
  @Prop({ default: "Id" })
  private itemKey: string;

  /**
   * 父节点
   */
  @Prop({ default: "ParentId" })
  private parentKey: string;

  /**
   * 绑定的位置
   */
  @Prop({ default: "loc" })
  private locationKey: string;

  @Prop({ default: undefined })
  private fromKey: string;

  @Prop({ default: undefined })
  private toKey: string;

  /**
   * diagram 配置类型
   */
  @Prop({ default: "model" })
  private type!: "model" | "tree" | "graph";

  /**
   * 获取图像配置
   */
  public get Diagram(): go.Diagram | undefined {
    if (this.diagram) {
      return this.diagram;
    }
  }
  /**
   * 获取树垂直布局
   */
  public get treeVerticalLayout() {
    let layout = this.make(go.TreeLayout, {
      treeStyle: go.TreeLayout.StyleLastParents,
      // arrangement: go.TreeLayout.AlignmentBus,
      // properties for most of the tree:
      angle: 90,
      layerSpacing: 80,
      // properties for the "last parents":
      alternateAngle: 90,
      alternateLayerSpacing: 35,
      alternateAlignment: go.TreeLayout.AlignmentCenterChildren,
      alternateNodeSpacing: 20
    });
    return layout;
  }

  public get treeLinkTemplate() {
    return this.make(
      go.Link,
      go.Link.Orthogonal,
      { corner: 5, relinkableFrom: true, relinkableTo: true },
      this.make(go.Shape, { strokeWidth: 4, stroke: "#00a4a4" })
    );
  }

  created() {
    this.id = this.$guid();
  }

  mounted() {
    let diagram = this.make(go.Diagram, this.id, {
      "undoManager.isEnabled": true
    });
    this.diagram = diagram;
    diagram.nodeTemplate = this.make(go.Node, go.Node.Auto, [
      new go.Binding("location", this.locationKey, go.Point.parse).makeTwoWay(
        go.Point.stringify
      )
    ]);
    this.createModel();
  }

  @Watch("type")
  private createModel() {
    if (this.diagram) {
      switch (this.type) {
        case "tree":
          let treeModel = new go.TreeModel();
          treeModel.nodeParentKeyProperty = this.parentKey;
          this.diagram.model = treeModel;
          break;
        case "graph":
          let graphModel = new go.GraphLinksModel();
          if (this.fromKey) {
            graphModel.linkFromKeyProperty = this.fromKey;
          }
          if (this.toKey) {
            graphModel.linkToKeyProperty = this.toKey;
          }
          this.diagram.model = graphModel;
          break;
        default:
          break;
      }
      this.diagram.model.nodeKeyProperty = this.itemKey;
    }
  }
  private id = "diagram";
  private make = go.GraphObject.make;
  private diagram: go.Diagram | undefined = undefined;

  private test(){
    if(this.diagram){
      // this.diagram
    }
  }
}
